export default __webpack_public_path__ + "static/media/naoki-saito.fe86e789.jpg";